import styled, { css, DefaultTheme } from 'styled-components';
import { ToastContainer } from 'react-toastify';

import { maxLines } from 'styles/mixins';

import { ToastVariant } from './types';

type Variant = keyof typeof ToastVariant;

export const Container = styled(ToastContainer)`
  width: 400px;

  position: fixed;
  padding: 0;
  z-index: 1000;

  ${({ theme }) => css`
    &.Toastify__toast-container--top-right {
      top: ${theme.padding.biggest};
      right: ${theme.padding.biggest};
    }

    .Toastify__toast {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      position: relative;
      padding: 0;
      background-color: transparent;
      overflow: hidden auto;
      direction: ltr;
      margin-bottom: 1rem;
    }

    .Toastify__toast-body {
      display: flex;
      align-items: center;
      flex: 1 1 auto;
      padding: 0;
      margin: 0;
    }
  `}
`;

const backgroundColor = (variant: Variant) => {
  switch (variant) {
    case 'success':
      return css`
        background: rgba(36, 38, 34, 0.5);
      `;
    case 'error':
      return css`
        background: rgba(81, 28, 26, 0.5);
      `;
  }
};

const border = (theme: DefaultTheme, variant: Variant) => {
  switch (variant) {
    case 'success':
      return css`
        border: 1px solid ${theme.colors.white.main};
      `;
    case 'error':
      return css`
        border: 1px solid ${theme.colors.red.main};
      `;
  }
};

const svgColor = (theme: DefaultTheme, variant: Variant) => {
  switch (variant) {
    case 'success':
      return theme.colors.white.main;
    case 'error':
      return theme.colors.red.main;
  }
};

export const CustomToastContainer = styled.div<{ variant: Variant }>`
  min-height: 56px;
  backdrop-filter: blur(10px);

  display: flex;
  overflow: hidden;
  flex-direction: row;
  align-items: center;

  ${({ theme, variant }) => css`
    ${border(theme, variant)};
    ${backgroundColor(variant)};

    svg {
      flex-shrink: 0;
      path {
        fill: ${svgColor(theme, variant)};
      }
    }

    p {
      ${maxLines(4)};
      color: ${theme.colors.white.main};
    }

    gap: ${theme.padding.small};
    padding: ${theme.padding.small};
    border-radius: ${theme.borderRadius.biggest};
  `}
`;
